"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _excluded = ["onChange", "size", "label", "onColour", "offColour", "disabled", "initialState", "id", "borderColor"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var calculateToggleHeight = function calculateToggleHeight(width) {
  return Math.floor(width / 2) + "px";
};

var calculateSwitchSize = function calculateSwitchSize(width) {
  return Math.floor(width / 3) + "px";
};

var calculateSwitchMargin = function calculateSwitchMargin(width) {
  return Math.floor(width / 10) + "px";
};

var HiddenCheckbox = _styledComponents["default"].input.attrs({
  type: "checkbox"
}).withConfig({
  displayName: "Toggle__HiddenCheckbox",
  componentId: "sc-yk8hl9-0"
})(["", ""], (0, _polished.hideVisually)());

var Wrapper = _styledComponents["default"].label.withConfig({
  displayName: "Toggle__Wrapper",
  componentId: "sc-yk8hl9-1"
})(["opacity:", ";cursor:", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 0.6 : 1;
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? "not-allowed" : "auto";
});

var Track = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Toggle__Track",
  componentId: "sc-yk8hl9-2"
})(["flex-shrink:0;border-style:", ";border-width:0.5px;"], function (_ref3) {
  var borderColor = _ref3.borderColor;
  return borderColor ? "solid" : "none";
});
var TrackBall = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Toggle__TrackBall",
  componentId: "sc-yk8hl9-3"
})(["flex-shrink:0;border-style:", ";border-width:0.5px;"], function (_ref4) {
  var borderColor = _ref4.borderColor;
  return borderColor ? "solid" : "none";
});
var Label = (0, _styledComponents["default"])(_Text["default"]).withConfig({
  displayName: "Toggle__Label",
  componentId: "sc-yk8hl9-4"
})(["user-select:none;"]);
/* eslint-disable jsx-a11y/label-has-associated-control */

var Toggle = function Toggle(_ref5) {
  var onChange = _ref5.onChange,
      size = _ref5.size,
      label = _ref5.label,
      onColour = _ref5.onColour,
      offColour = _ref5.offColour,
      disabled = _ref5.disabled,
      initialState = _ref5.initialState,
      id = _ref5.id,
      borderColor = _ref5.borderColor,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref5, _excluded);

  var _useState = (0, _react.useState)(false),
      isToggled = _useState[0],
      setIsToggled = _useState[1];

  (0, _react.useEffect)(function () {
    setIsToggled(initialState);
  }, [initialState]);

  var handleChange = function handleChange(e) {
    setIsToggled(e.target.checked);
    onChange(e.target.checked);
  };

  var ToggleSwitch = function ToggleSwitch() {
    return /*#__PURE__*/_react["default"].createElement(Track, {
      borderRadius: 999,
      mr: 3,
      bg: isToggled ? onColour : offColour,
      width: size + "px",
      height: calculateToggleHeight(size),
      justifyContent: isToggled ? "flex-end" : "flex-start",
      alignItems: "center",
      borderColor: borderColor
    }, /*#__PURE__*/_react["default"].createElement(TrackBall, {
      isToggled: isToggled,
      width: calculateSwitchSize(size),
      height: calculateSwitchSize(size),
      borderRadius: "50%",
      bg: borderColor || "light.0",
      borderColor: borderColor,
      mx: calculateSwitchMargin(size)
    }));
  };

  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    disabled: disabled
  }, /*#__PURE__*/_react["default"].createElement(HiddenCheckbox, (0, _extends2["default"])({
    id: id,
    checked: isToggled,
    disabled: disabled,
    onChange: function onChange(e) {
      return handleChange(e);
    }
  }, props)), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    alignItems: "center",
    flexDirection: "row"
  }, /*#__PURE__*/_react["default"].createElement(ToggleSwitch, null), label && typeof label === "string" ? /*#__PURE__*/_react["default"].createElement(Label, {
    fontSize: 2,
    color: "dark.2"
  }, label) : label));
};

Toggle.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  size: _propTypes["default"].number,
  label: _propTypes["default"].node,
  onColour: _propTypes["default"].string,
  offColour: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  initialState: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired
};
Toggle.defaultProps = {
  size: 20,
  label: "",
  onColour: "primary.0",
  offColour: "dark.2",
  disabled: false,
  initialState: false
};
var _default = Toggle;
exports["default"] = _default;